module.exports = __webpack_public_path__ + "3bb34e765d5e89118e430b631f214493.MP3";